// Self-contained confetti burst for the Publish success moment (no dependency).
const COLORS = ["#FF5700", "#25A97A", "#316BFF", "#F0A030", "#9B6BD8"];

let _styleInjected = false;

function injectStyle() {
  if (_styleInjected) return;
  _styleInjected = true;
  const style = document.createElement("style");
  style.textContent = `
    .aiw2-confetti-layer { position: fixed; inset: 0; pointer-events: none; z-index: 9999; overflow: hidden; }
    .aiw2-confetti-piece { position: absolute; top: -12px; width: 8px; height: 14px; opacity: 0.9; will-change: transform; }
    @keyframes aiw2ConfettiFall {
      0% { transform: translateY(-10vh) rotateZ(0deg); }
      100% { transform: translateY(110vh) rotateZ(720deg); }
    }
  `;
  document.head.appendChild(style);
}

export function celebrate() {
  injectStyle();
  const layer = document.createElement("div");
  layer.className = "aiw2-confetti-layer";
  for (let i = 0; i < 60; i++) {
    const piece = document.createElement("span");
    piece.className = "aiw2-confetti-piece";
    piece.style.left = Math.random() * 100 + "vw";
    piece.style.background = COLORS[i % COLORS.length];
    const duration = 1.6 + Math.random() * 1.2;
    piece.style.animation = `aiw2ConfettiFall ${duration}s linear forwards`;
    piece.style.animationDelay = Math.random() * 0.4 + "s";
    layer.appendChild(piece);
  }
  document.body.appendChild(layer);
  setTimeout(() => {
    if (layer.parentNode) layer.parentNode.removeChild(layer);
  }, 3200);
}
